










import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class CardSnackBar extends Vue {
  @Prop() readonly text!: string;
  @Prop() readonly snackbar!: boolean;
  timeout = 2000;
}
